// Config object to be passed to Msal on creation
export const msalConfig = {
    // Dev
    // auth: {
    //     clientId: "d6470719-020b-4330-958d-fd0eeef6d07b",
    //     authority: "https://auth03coll.giustizia.it/b2cmingiustiziaspidcoll.onmicrosoft.com/b2c_1a_signin_aad_spid/",
    //     knownAuthorities: ["https://auth03coll.giustizia.it"],
    //     redirectUri: "https://localhost:44498/amministrazione",
    //     postLogoutRedirectUri: "https://localhost:44498/amministrazione"
    // },
    // Collaudo
    auth: {
        clientId: window._env_.B2C_CLIENT_ID,
        authority: window._env_.B2C_AUTHORITY,
        knownAuthorities: [window._env_.B2C_KNOWN_AUTHORITY],
        redirectUri: window._env_.B2C_REDIRECT_URI,
        postLogoutRedirectUri: window._env_.B2C_POST_LOGOUT_REDIRECT_URI
    },
};

// Scopes you add here will be prompted for consent during login
export const loginRequest = {
    // Dev
    // scopes: ["https://b2cmingiustiziaspidcoll.onmicrosoft.com/GiustiziaAPI/giustizia.map"]
    // Collaudo
    scopes: [window._env_.B2C_SCOPE]
};
